module.exports = __webpack_public_path__ + "img/Katarina_acc_09.8b091c38.jpg";